import React, { useEffect, useState } from 'react';
import "./inputicon.scss";
import search from '../../assets/svg/ic-actions-searchReverse.svg';
import IconView from '../../assets/svg/ic-actions-view.svg';
import IconCloseView from '../../assets/svg/ic-actions-closed-view.svg';
import { Link } from 'react-router-dom';
// theme={2}
// label="Nome do usuário"
// icon={}

const InputFileIcon = ({ placeholder, value, onChange, onKeyUp, theme, label, icon, opcional, children, type = "text", fileType = [], urlToDownload, uploadStatus, width, accept, disabled = false }) => {
    const [typeState, setTypeState] = useState(type);
    const [fileName, setFileName] = useState(urlToDownload ? 'Arquivo anexado' : placeholder);
    const [imagePreview, setImagePreview] = useState(urlToDownload);

    const InputRef = React.createRef();

    useEffect(() => {
        setTypeState(type);
    }, [type]);

    const renderStyle = () => {
        let stl = "gb-cont-input-icon";
        if (theme) {
            if (theme == 2)
                stl = stl + " gb-cont-input-file-theme2";
        }

        return stl;
    }

    const openSelectFile = () => {
        InputRef.current.click();
    }
    const fileSelected = (ev) => {
        console.log(InputRef.current.files);

        if (InputRef.current.files && InputRef.current.files.length > 0) {
            // let ext = InputRef.current.files[0].name.split('.')[InputRef.current.files[0].name.split('.').length - 1];
            // console.log(ext.toString(), fileType, fileType.includes[ext.toString()])
            // if (fileType.length > 0 && !fileType.includes[ext]) {
            //         alert('Tipo de Arquivo não permitido!');
            //         InputRef.current.value = null;
            //         return;                
            // }
            if (onChange) {
                setImagePreview(null)
                onChange(InputRef.current.files);
            }
            setFileName(InputRef.current.files[0].name)
            if (InputRef.current.files[0].type.indexOf('image') >= 0) {
                var reader = new FileReader();
                reader.readAsDataURL(InputRef.current.files[0]);
                reader.onloadend = function (e) {
                    setImagePreview(reader.result);
                }.bind(this);

            }
        }
    }
    const openFile = e => {
        e.preventDefault();
        window.open(urlToDownload)
    }

    const renderInput = () => {
        return (
            <div>
                <div
                    className={" noPaddingRight " + renderStyle()}
                    style={{ paddingRight: '0px !important', width: width ? width : '' }}
                    width={width}
                    onClick={openSelectFile}
                >
                    <div className="gb-input-icon" >
                        <img src={icon ? icon : search} width="20" height="20" />
                    </div>
                    <input
                        type="file"
                        ref={InputRef}
                        onChange={fileSelected}
                        style={{ visibility: 'hidden', width: '1px', height: '1px !important' }}
                        accept={accept}
                        disabled={disabled}
                    />

                    <input type="text" disabled placeholder={placeholder} value={fileName} />
                    {uploadStatus ? (
                        <div className="spinner-border spinner-border-sm fileLoadingStatus" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                    ) : null}
                    {urlToDownload ? (
                        <button className="gb-file-button bg2" style={{ borderRadius: 0 }} onClick={openFile}>
                            <i className="fa fa-external-link-alt" />
                        </button>
                    ) : null}
                    <button className="gb-file-button">
                        {urlToDownload && urlToDownload != '' ? 'Alterar' : 'Selecionar'}
                    </button>
                </div>
                {imagePreview ? (
                    <div className="gb-image-preview">
                        <img src={imagePreview} />
                    </div>
                ) : null}
            </div>
        );
    }

    const renderInputWithLabel = () => {
        return (
            <div>
                <label className="gb-input-label">{label}{opcional ? <span style={{ opacity: 0.46, fontStyle: 'italic', fontSize: 14 }}> - Opcional</span> : ''}</label>
                {renderInput()}
            </div>
        )
    }

    const renderAll = () => {
        if (theme) {
            if (theme == 2)
                return renderInputWithLabel();
            else return renderInput();
        } else return renderInput();
    }

    return (
        <>
            {renderAll()}
        </>
    )

}

export default InputFileIcon;